import { resolvePatch } from '../../trace/ports.js';
import { defineRule } from '../rule.js';

/** "SB1 / 9", "sb1:9" → "sb1/9": informal patch texts compared without spelling. */
function patchKey(text: string): string {
  return text
    .trim()
    .toLowerCase()
    .replace(/\s*[:/ ]\s*(\d+)$/u, '/$1');
}

/**
 * W: two channels patched to the same stage-box input by text (`Channel.patch`), e.g. ch 9 and
 * ch 10 both on "SB1/9" (exploratory test OIL-149). Texts resolving to a port count by that port.
 */
export const patchDoubleBooked = defineRule(
  'patch-double-booked',
  'warning',
  { en: 'Patch used twice', de: 'Patch doppelt belegt' },
  (data, emit) => {
    const by = new Map<string, { text: string; ids: string[]; numbers: number[] }>();
    const channels = Object.values(data.channels).sort((a, b) => a.number - b.number);
    for (const ch of channels) {
      const text = ch.patch?.trim() ?? '';
      if (text === '') continue;
      const port = resolvePatch(data, text);
      const key = port === undefined ? patchKey(text) : `${port.itemId}#${port.portId}`;
      const entry = by.get(key) ?? { text, ids: [], numbers: [] };
      entry.ids.push(ch.id);
      entry.numbers.push(ch.number);
      by.set(key, entry);
    }
    return [...by.values()]
      .filter((e) => e.ids.length > 1)
      .map((e) => emit(e.ids, { patch: e.text, channels: e.numbers.join(', ') }));
  },
);
